/**
 * Success Animation Assets
 *
 * Lottie animations for success and completion states.
 */

import type { AnimationAsset } from './loading';

/**
 * Base path for animation assets
 */
const ANIMATIONS_BASE = '/assets/animations';

/**
 * Success animation variants
 */
export const SUCCESS_ANIMATIONS = {
  check: {
    path: `${ANIMATIONS_BASE}/success-check.json`,
    name: 'Success Check',
    loop: false,
    autoplay: true,
  },
  confetti: {
    path: `${ANIMATIONS_BASE}/success-confetti.json`,
    name: 'Confetti',
    loop: false,
    autoplay: true,
  },
  celebration: {
    path: `${ANIMATIONS_BASE}/success-celebration.json`,
    name: 'Celebration',
    loop: false,
    autoplay: true,
  },
  fireworks: {
    path: `${ANIMATIONS_BASE}/success-fireworks.json`,
    name: 'Fireworks',
    loop: false,
    autoplay: true,
  },
  trophy: {
    path: `${ANIMATIONS_BASE}/success-trophy.json`,
    name: 'Trophy',
    loop: false,
    autoplay: true,
  },
} as const;

/**
 * Success animation types
 */
export type SuccessAnimationType = keyof typeof SUCCESS_ANIMATIONS;

/**
 * Get success animation
 */
export function getSuccessAnimation(type: SuccessAnimationType = 'check'): AnimationAsset {
  return SUCCESS_ANIMATIONS[type];
}
